// source: type/price_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.type.PriceType', null, global);
/**
 * @enum {number}
 */
proto.type.PriceType = {
  PRICE_TYPE_UNSPECIFIED: 0,
  PRICE_TYPE_10_PERCENT_TAX_EXCLUDED: 1,
  PRICE_TYPE_08_PERCENT_TAX_EXCLUDED: 2,
  PRICE_TYPE_10_PERCENT_TAX_INCLUDED: 3,
  PRICE_TYPE_08_PERCENT_TAX_INCLUDED: 4,
  PRICE_TYPE_TAX_EXEMPT: 5
};

goog.object.extend(exports, proto.type);
